import { useGetMyBugReports } from '../../../redux/api/bugReportApi';

export function useBugReports() {
  const {
    data: myReports,
    refetch,
    isLoading,
    isFetching,
    isError,
    error,
  } = useGetMyBugReports();

  return {
    reports: myReports,
    refetch,
    isLoading,
    isFetching,
    isError,
    error,
  };
}
